import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
	postOtpValidate,
	postOtpSend,
	OtpValidateParams,
	OtpValidateResponse,
	OtpSendParams,
	OtpSendResponse,
} from 'src/components/OTP/utils/api';

export const useOtpValidateMutation = (
	options?: UseMutationOptions<OtpValidateResponse, Error, OtpValidateParams>,
) => {
	return useMutation<OtpValidateResponse, Error, OtpValidateParams>({
		mutationFn: postOtpValidate,
		...options,
	});
};

export const useOtpSendMutation = (
	options?: UseMutationOptions<OtpSendResponse, Error, OtpSendParams>,
) => {
	return useMutation<OtpSendResponse, Error, OtpSendParams>({
		mutationFn: postOtpSend,
		...options,
	});
};

